import { useState } from "react";
import Button from "src/components/atoms/Button";
import AddEventDialog from "../organisms/AddEventDialog";

const CreateEventButton = (props) => {
	const [showModalForm, setShowModalForm] = useState(false);

	return (
		<>
			<Button
				onClick={() => setShowModalForm(true)}
				{...props}
				text="Create an Event"
			/>
			{showModalForm && (
				<AddEventDialog setShowModalForm={setShowModalForm} />
			)}
		</>
	);
};

export default CreateEventButton;
